import { BodyWrappers } from "../styleds";

export const Layout = ({ wrapperProps, children }) => {
  return <BodyWrappers {...wrapperProps}>{children}</BodyWrappers>;
};
